import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// portal
import { environment } from '@open-portal-env';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  constructor(private route: ActivatedRoute) { }

  // On load, this page redirects user to Auth0 universal login page
  //  and provides Auth0 with a url(in param "next") to which user is redirected back, after authentication
  //  The url provided is root url with queryParams to be used in handover guard.
  //  By default authenticated action is "dashboard", until one is provided in queryParams
  // Example of url for login page:
  //  - DEFAULT:
  //      "/login?partner=partnerApiKey&redirect=partnerUrl&action=desiredAction
  ngOnInit(): void {
    let partnerApiKey = this.route.snapshot.queryParams.partner;
    let redirect = this.route.snapshot.queryParams.redirect;
    let action = this.route.snapshot.queryParams.action || 'dashboard';
    let subject = this.route.snapshot.queryParams.subject;
    let intent = this.route.snapshot.queryParams.intent;
    let entity = this.route.snapshot.queryParams.entity;
    let ref = this.route.snapshot.queryParams.ref;
    // Url to come back to portal after successful login from Auth0
    let nextUrl;
    let url;

    // For customers using login link from email sent by agents(trigerred from Central)
    // This helps to prefill email in universal login page
    let connection = this.route.snapshot.queryParams.c ? '&c=' + this.route.snapshot.queryParams.c : '';
    let loginHint = this.route.snapshot.queryParams.l ?
      '&l=' + encodeURIComponent(this.route.snapshot.queryParams.l) :
      '';

    if (this.route.snapshot.data.partnerLoginDetails) {
      let clientId = this.route.snapshot.data.partnerLoginDetails.auth0_client_id;
      let partnerSlug = this.route.snapshot.data.partnerLoginDetails.slug;
      let is_auth0_enabled = this.route.snapshot.data.partnerLoginDetails.is_auth0_enabled;

      // Set client Id to be available in portal service for redirects to PortalV1
      window.sessionStorage.setItem('clientId', clientId);

      if (is_auth0_enabled) {
        // Redirect to Auth0 universal login page
        const queryParams = [
          `partner=${partnerSlug}`,
          `key=${partnerApiKey}`,
          redirect ? `redirect=${redirect}` : '',
          `action=${action}`,
          action === 'help_flow' ? `subject=${subject}&customer-intent=${intent}` : '',
          entity ? `entity=${entity}` : '',
          ref ? `ref=${ref}` : ''
        ]
        .filter(Boolean);

        const queryString = queryParams.join('&');
        nextUrl = encodeURIComponent(`${window.location.origin}?${queryString}`);
        url = `${environment.apiEndpoint}/u/login?client_id=${clientId}${connection}${loginHint}&next=${nextUrl}`;

        window.open(url, '_self');
      }
    }
  }
}
